import { Sidebar as WdsSidebar, ItemProps as WdsItemProps } from "@datamole/wds-component-sidebar";
import { clsx } from "clsx";
import { ReactNode, forwardRef } from "react";

import styles from "@/components/shared/app-layout/sidebar/sidebar-item/button-sidebar-item/button-sidebar-item.module.css";

interface Props extends WdsItemProps {
    children: ReactNode;
    className?: string;
    icon?: ReactNode;
}

export const ButtonSidebarItem = forwardRef<HTMLAnchorElement, Props>(
    ({ children, icon, className, ...rest }: Props, ref) => {
        return (
            <WdsSidebar.Item ref={ref} className={clsx(styles.button_sidebar_item, className)} {...rest}>
                {icon && (
                    <WdsSidebar.Item.Icon className={styles.button_sidebar_item_icon}>{icon}</WdsSidebar.Item.Icon>
                )}
                {children && <WdsSidebar.Item.Content>{children}</WdsSidebar.Item.Content>}
            </WdsSidebar.Item>
        );
    }
);

ButtonSidebarItem.displayName = "ButtonSidebarItem";
